import i18n from 'i18next'

export default function () {
    return Object.freeze(
        {
            nps: i18n.t('powerpoint.options.chart.nps'),
            matrix: i18n.t('powerpoint.options.chart.matrix'),
            standardColumn: i18n.t('powerpoint.options.chart.standardColumn'),
            standardBar: i18n.t('powerpoint.options.chart.standardBar'),
            stackedBar: i18n.t('powerpoint.options.chart.stackedBar'),
            stackedColumn: i18n.t('powerpoint.options.chart.stackedColumn'),
            noRanking: i18n.t('powerpoint.options.ranking.noRanking'),
            lowToHigh: i18n.t('powerpoint.options.ranking.lowToHigh'),
            highToLow: i18n.t('powerpoint.options.ranking.highToLow'),
            aToZ: i18n.t('powerpoint.options.ranking.aToZ'),
            baseSize: i18n.t('powerpoint.options.ranking.baseSize'),
            industry: i18n.t('powerpoint.options.ranking.industry'),
            company: i18n.t('powerpoint.options.ranking.company'),
            sector: i18n.t('powerpoint.options.ranking.sector'),
            portfolio: i18n.t('powerpoint.options.ranking.portfolio'),
            average: i18n.t('powerpoint.options.display.average'),
            top2: i18n.t('powerpoint.options.display.top2'),
            chartType: 'chartType',
            locked: 'locked',
            excludeNonNumeric: 'excludeNonNumeric',
            kpiPageQuestionId: 'kpiPageQuestionId',
            kpiId: 'kpiId',
            overallShowScore: 'overallShowScore',
            comparisonSurveyIds: 'comparisonSurveyIds',
            parentDataRanking: 'parentDataRanking',
            ranking: 'ranking',
            removeBaseLimit: 'removeBaseLimit',
            childPageQuestionId: 'childPageQuestionId',
            pageQuestionId: 'pageQuestionId',
            questionId: 'questionId',
            kind: 'kind',
            display: 'display',
            benchmarks: 'benchmarks',
            comment: 'comment',
        },
    )
}
